function crontab() {
  return (hljs) => ({
    name: "crontab",
    disableAutodetect: true,
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        className: "keyword",
        match:
          /@(?:annually|daily|hourly|midnight|monthly|reboot|weekly|yearly)\b/,
      },
      {
        className: "built_in",
        match: /(?<!\w)--?[a-zA-Z][\w-]*/,
      },
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
    ],
  });
}

export default crontab;
